import Flickity from 'flickity';
import 'flickity-fade';
import { gsap, Observer } from '../global/gsap';

const initHero = (element) => {
    const track = element.querySelector('.js-hero-track');

    const flickityOptions = {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        fade: true
    };

    const carousel = new Flickity(track, flickityOptions);

    // Custom nav
    const next = element.querySelector('.js-hero-next');
    const prev = element.querySelector('.js-hero-prev');

    if (next) {
        next.addEventListener('click', () => {
            carousel.next(true, false);
        });
    }

    if (prev) {
        prev.addEventListener('click', () => {
            carousel.previous(true, false);
        });
    }

    // Counter stuff
    const counter = element.querySelector('.js-hero-counter');

    if (counter) {
        const active = counter.querySelector('.active');

        carousel.on('change', (index) => {
            active.textContent = index + 1;
        });
    }

    // Cursor
    const cursor = element.querySelector('.js-hero-cursor');

    if (cursor) {
        const cursorTo = (xCoord, yCoord, target) => {
            const tl = gsap.timeline({
                ease: 'linear',
                overwrite: true
            });

            // Show mediaOuter on hover, slight delayed fade
            if (!element.classList.contains('show-cursor')) {
                element.classList.add('show-cursor');
            }

            if (target.classList.contains('js-hero-next')) {
                cursor.classList.add('show-next');
            } else if (target.classList.contains('js-hero-prev')) {
                cursor.classList.remove('show-next');
            } else {
                element.classList.remove('show-cursor');
            }

            tl.to(cursor, {
                y: yCoord,
                x: xCoord,
            });
        };

        const matchMedia = gsap.matchMedia();

        matchMedia.add('(min-width: 37.5em)', () => {
            const observerObject = Observer.create({
                target: element,
                type: 'pointer',
                onHoverEnd: () => {
                    element.classList.remove('show-cursor');
                },
                onMove: (self) => {
                    cursorTo(self.x, self.y, self.event.target);
                }
            });

            // Kill Observer on change to mobile
            return () => {
                observerObject.kill();
            };
        });
    }
};

export { initHero as default };
